import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  fetchConversationsFailure,
  fetchConversationsSuccess,
} from "../slices/features/conversations";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* fetchConversationsSaga(action: any) {
  const { payload } = action;
  const { id, meta } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.fetchConversations,
      baseUrl,
      id,
      meta
    );

    yield put(fetchConversationsSuccess({ ...response }));

    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(fetchConversationsFailure({ statusCode, statusText }));
  }
}

export function* watchfetchConversations() {
  yield takeLatest(
    RequestTypes.GET_CONVERSATIONS_REQUEST,
    fetchConversationsSaga
  );
}
